import api from './api';

export type EmpresaResumen = {
  id: number; nombre: string; slug: string; rut?: string; activo: boolean; fechaCreacion: string;
  pisos: number; areas: number; tareas: number; tiposArea: number; registros: number;
};

export type EmpresaItem = {
  id: number; nombre: string; slug: string; rut?: string; activo: boolean; fechaCreacion: string;
};

export type PlanRestrictions = {
  maxPisos: number;
  maxAreas: number;
  maxUsuarios: number;
  maxMensajes: number;
  features: string[];
};

export type PlanItem = {
  id: number; 
  nombre: string; 
  codigo: string; 
  descripcion?: string; 
  activo: boolean; 
  featureFlagsJson?: string;
  fechaCreacion: string;
  restrictions?: PlanRestrictions;
};

export type SuscripcionItem = {
  id: number;
  empresaId: number;
  empresaNombre: string;
  planId: number;
  planNombre: string;
  estado: string;
  periodo: 'Mensual' | 'Anual' | string;
  fechaInicio: string;
  fechaFin?: string;
  renuevaAutomatico: boolean;
  featureOverridesJson?: string;
};



export const superAdminService = {
  async getEmpresasResumen(): Promise<EmpresaResumen[]> {
    const { data } = await api.get('/SuperAdmin/empresas/resumen');
    return data;
  },
  async getEmpresas(): Promise<EmpresaItem[]> {
    const { data } = await api.get('/SuperAdmin/empresas');
    return data;
  },
  async createEmpresa(payload: { nombre: string; rut: string; activo?: boolean }): Promise<EmpresaItem> {
    const { data } = await api.post('/SuperAdmin/empresas', { ...payload, activo: payload.activo ?? true });
    return data;
  },
  async updateEmpresa(id: number, payload: { nombre: string; slug: string; activo: boolean; rut?: string }): Promise<EmpresaItem> {
    const { data } = await api.put(`/SuperAdmin/empresas/${id}`, payload);
    return data;
  },
  async deleteEmpresa(id: number): Promise<void> {
    await api.delete(`/SuperAdmin/empresas/${id}`);
  },
  async getPlanes(): Promise<PlanItem[]> {
    const { data } = await api.get('/SuperAdmin/planes');
    return data;
  },
  async createPlan(payload: { nombre: string; codigo: string; descripcion?: string; activo?: boolean; featureFlagsJson?: string }): Promise<PlanItem> {
    const { data } = await api.post('/SuperAdmin/planes', { ...payload, activo: payload.activo ?? true });
    return data;
  },
  async updatePlan(id: number, payload: { nombre: string; descripcion?: string; activo: boolean; featureFlagsJson?: string }): Promise<PlanItem> {
    const { data } = await api.put(`/SuperAdmin/planes/${id}`, payload);
    return data;
  },
  async deletePlan(id: number): Promise<void> {
    await api.delete(`/SuperAdmin/planes/${id}`);
  },
  async getSuscripciones(): Promise<SuscripcionItem[]> {
    const { data } = await api.get('/SuperAdmin/suscripciones');
    return data;
  },
  async createSuscripcion(payload: { empresaId: number; planId: number; periodo?: 'Mensual' | 'Anual'; renuevaAutomatico?: boolean; featureOverridesJson?: string }): Promise<SuscripcionItem> {
    const { data } = await api.post('/SuperAdmin/suscripciones', { renuevaAutomatico: true, periodo: 'Mensual', ...payload });
    return data;
  },
  async updateSuscripcion(id: number, payload: { estado: string; planId?: number; periodo?: 'Mensual' | 'Anual'; renuevaAutomatico: boolean; fechaInicio?: string; fechaFin?: string; featureOverridesJson?: string }): Promise<SuscripcionItem> {
    const { data } = await api.put(`/SuperAdmin/suscripciones/${id}`, payload);
    return data;
  },
  async deleteSuscripcion(id: number): Promise<void> {
    await api.delete(`/SuperAdmin/suscripciones/${id}`);
  },
};
